<template>
  <div class="response-detail atb-flex atb-flex-column">
    <div class="header atb-flex atb-flex-items-center">
      <div class="month-title">
        <h2 v-if="detail.year">{{ detail.year }} / {{ detail.wkName }}</h2>
        <span class="saveStatus">{{ saveStatus }}</span>
      </div>
    </div>
    <div class="container atb-content-bg atb-flex atb-flex-column">
      <div class="search-and-content atb-flex atb-flex-column" id="all">
        <div class="search">
          <div class="function atb-flex">
            <el-form :inline="true" class="atb-input">
              <el-form-item v-if="isEditOrApproveEdit">
                <el-button :disabled="pending" type="primary" @click="clickSave">保存</el-button>
              </el-form-item>
              <el-form-item v-if="isEditable">
                <el-button type="primary" @click="showSubmit = true">提交</el-button>
              </el-form-item>
              <el-form-item v-if="isApprovePending && msgId">
                <el-button type="primary" @click="showApprove = true">通过</el-button>
              </el-form-item>
              <el-form-item v-if="isApprovePending && msgId">
                <el-button type="refuse" @click="showCompleteApprove = true">驳回</el-button>
              </el-form-item>
              <el-form-item v-if="isConfirmPending">
                <el-button :disabled="pending" type="primary" @click="showConfirmResult">确认</el-button>
              </el-form-item>
              <!-- <el-form-item v-if="msgId && editStatus === 'edit'">
                <el-button plain type="downloadTemplate" @click="showApproveReason = true">审批意见</el-button>
              </el-form-item> -->
              <el-form-item>
                <el-button type="downloadTemplate" plain @click="exportExcel">导出</el-button>
              </el-form-item>
              <el-form-item>
                <el-button plain type="downloadTemplate" @click="expandRowAll">{{expandRowAllFlag ? "收起全部" : "展开全部"}}</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="table-content atb-flex atb-flex-column kpi">
          <table class="personal-table">
            <thead>
              <tr class="label-row">
                <td width="33.3333%"><div class="personal-label">制定人</div></td>
                <td width="33.3333%"><div class="personal-label">制定日期</div></td>
                <td width="33.3333%"><div class="personal-label required-field">部门</div></td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <selecter
                    v-if="isEditOrApproveEdit"
                    class="table-field"
                    ref="formulatSelect"
                    v-model="detail.formulatNo"
                    placeholder="输入工号或姓名查询"
                    :jobNo="detail.formulatNo"
                    :name="detail.formulatName"
                    @change="formulatChange"
                  ></selecter>
                  <div v-else class="default-text">{{ detail.formulatName }}</div>
                </td>
                <td>
                  <div class="default-text" v-if="detail.formulatDate">{{ formatDate(detail.formulatDate, 'yyyy-MM-dd') }}</div>
                  <div class="default-text--disabled" v-else>提交后自动生成</div>
                </td>
                <td>
                  <DeptSelecter v-if="isEditOrApproveEdit && detail.allowDeptEdit === 1" :deptInfo="deptInfo" @change="deptChange" @hide="deptPopHide"></DeptSelecter>
                  <div class="default-text" v-else>{{ detail.department }}</div>
                </td>
              </tr>
              <tr class="label-row">
                <td width="33.3333%"><div class="personal-label">员工姓名</div></td>
                <td width="33.3333%"><div class="personal-label">员工工号</div></td>
                <td width="33.3333%"><div class="personal-label required-field">岗位名称</div></td>
              </tr>
              <tr>
                <td>
                  <div class="default-text">{{ detail.wkName }}</div>
                </td>
                <td>
                  <div class="default-text">{{ detail.wkNo }}</div>
                </td>
                <td>
                  <div class="table-field">
                    <el-input
                      v-if="isEditOrApproveEdit"
                      maxlength="128"
                      v-model="detail.jobName"
                      @blur="blurField()"
                      placeholder=""
                    ></el-input>
                    <div v-else class="default-text">{{ detail.jobName }}</div>
                  </div>
                </td>
              </tr>
              <tr class="label-row">
                <td width="33.3333%"><div class="personal-label required-field">直接上级</div></td>
                <td width="66.6666%"  colspan="2"><div class="personal-label">直接下属范围</div></td>
              </tr>
              <tr>
                <td>
                  <template v-if="status == 30">
                    <selecter
                      v-if="isAllowTemporaryEdit"
                      ref="superiorSelect"
                      v-model="detail.superiorNo"
                      placeholder="输入工号或姓名查询"
                      :jobNo="detail.superiorNo"
                      :name="detail.superiorName"
                      @change="superiorChange"
                    ></selecter>
                    <div v-else class="default-text">{{ detail.superiorName }}</div>
                  </template>
                  <template v-else>
                    <selecter
                      v-if="isEditOrApproveEdit"
                      ref="superiorSelect"
                      v-model="detail.superiorNo"
                      placeholder="输入工号或姓名查询"
                      :jobNo="detail.superiorNo"
                      :name="detail.superiorName"
                      @change="superiorChange"
                    ></selecter>
                    <div v-else class="default-text">{{ detail.superiorName }}</div>
                  </template>
                </td>
                <td colspan="2">
                  <div class="emp-range" ref="empRange" :class="{'emp-range--expand': expandRowAllFlag}">
                    <div class="float-empty" v-if="!expandRowAllFlag && isEditOrApproveEdit"></div>
                    <div class="select-btn-wrap" v-if="!expandRowAllFlag && isEditOrApproveEdit">
                      <span class="range-ellipse" v-if="isOverflowRange">···</span>
                    </div>
                    <el-button class="select-btn" v-if="isEditOrApproveEdit" type="primary" size="mini" @click="showSelectSubEmp">选择</el-button>
                    <el-tag
                      v-for="(tag, index) in detail.personSubDtos"
                      :key="tag.wkNo"
                      :closable="isEditOrApproveEdit"
                      @close="removeSubEmp(index)"
                    >
                      {{tag.wkName}}
                    </el-tag>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="detail-items">
            <DetailTable
              v-for="item in tableList"
              :key="item.workClassify"
              :tableDetail="item"
              :workId="id"
              :isEditable="isEditOrApproveEdit"
              :saveStatus.sync="saveStatus"
              :ref="item.tableRef"
              :isAllPending.sync="pending"
            ></DetailTable>
          </div>
        </div>
      </div>
    </div>

    <PersonSelecter v-if="isShowPersonSelecter" :isShowDialog.sync="isShowPersonSelecter" :dataList="detail.personSubDtos" @saveData="selectedSubEmps" />
   
    <el-dialog
      title="审批意见"
      :visible.sync="showApprove"
      width="500px"
      @close="closeApprove"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="content">
        <el-input type="textarea" :autosize="{ minRows: 5 }" :maxlength="$config.input.textareaMaxLength" placeholder="审批通过原因可不填" v-model="approveReason"> </el-input>
        <fast-approve @approveText="approveText"></fast-approve>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="updateStatus('access')">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="showApprove = false">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="审批意见"
      :visible.sync="showCompleteApprove"
      width="500px"
      @close="closeApprove"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="content">
        <el-input type="textarea" :autosize="{ minRows: 5 }" :maxlength="$config.input.textareaMaxLength" placeholder="审批驳回原因必须填写" v-model="approveReason"> </el-input>
        <fast-approve @approveText="approveText"></fast-approve>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="updateStatus('refuse')">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="showCompleteApprove = false">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog title="提交" :visible.sync="showSubmit" width="260px" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="content sub-content">
        <h2>确定要提交吗?</h2>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="submit">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="showSubmit = false">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="审批意见"
      :visible.sync="showApproveReason"
      width="500px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      class="footer-center"
    >
      <div class="content">
        {{ detail.approveReason || '无' }}
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-cancel" type="cancel" @click="showApproveReason = false">确认</el-button>
      </span>
    </el-dialog>
    <el-dialog title="确认" :visible.sync="isShowConfirmResult" width="260px" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="content sub-content">
        <h2>确定要提交吗?</h2>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="confirmResult">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="isShowConfirmResult = false">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog title="提示" :visible.sync="isShowConfirmResultTip" width="260px" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="content sub-content">
        <h2>请按需进行修改并点击确认</h2>
      </div>
      <div slot="footer" class="dialog-footer" style="text-align: center;">
        <el-button class="atb-dialog-cancel" type="cancel" @click="isShowConfirmResultTip = false">关闭</el-button>
      </div>
    </el-dialog>
    
  </div>
</template>
<script>
import XEUtils from 'xe-utils'
import _ from 'lodash';
import routeMixin from '@/mixins/route.mixin';
import DetailTable from './components/DetailTable.vue';
import DeptSelecter from './components/DeptSelecter.vue';
import PersonSelecter from './components/PersonSelecter.vue';
import Selecter from '@/component/global/customerSelect';

export default {
  name: 'ResponseDetail',
  inject: ['reload'],
  mixins: [routeMixin],
  components: {
    DetailTable,
    Selecter,
    DeptSelecter,
    PersonSelecter,
  },
  data() {
    return {
      tableList: [],
      id: '',
      detail: {},
      editStatus: '',
      deptInfo: {},
      responsWorkClassifys: [],

      showApprove: false,
      showCompleteApprove: false,
      showSubmit: false,

      isShowPersonSelecter: false,

      approveReason: '',
      saveStatus: '',

      pending: false,
      expandRowAllFlag: false,

      status: -1,

      showApproveReason: false,
      approveNo: '',
      loginWkNo: '',
      isShowConfirmResultTip: false,
      isShowConfirmResult: false,
      isOverflowRange: false,
      isTemporaryWkNo: false,
      timeoutSave: null,
    };
  },
  computed: {
    // 已保存/已驳回
    isEditable() {
      return this.editStatus === 'edit' && (this.status == 0 || this.status == 10);
    },
    // 已提交，正在审批
    isApprovePending() {
      return this.editStatus === 'approve' && this.status == 20;
    },
    // 已通过审批
    isApproved() {
      return this.editStatus === 'approve' && this.status == 30;
    },
    // 等待确认
    isConfirmPending() {
      return this.editStatus === 'approve' && this.status == 30 && this.detail.approveNo === this.loginWkNo;
    },
    // 自己编辑或审批人编辑
    isEditOrApproveEdit() {
      return this.isEditable || this.isConfirmPending;
    },
    isAllowTemporaryEdit() {
      return this.isConfirmPending && !this.isTemporaryWkNo;
    },
    // 已确认
    isConfirmed() {
      return this.editStatus === 'approve' && this.status == 50;
    },
  },

  created() {
    this.loginWkNo = sessionStorage.getItem('userInfo') ? JSON.parse(sessionStorage.getItem('userInfo')).wkNo : '';
    this.id = this.$route.query.id || '';
    this.msgId = this.$route.query.msgId || null;
    this.childIds = this.$route.query.childIds || null;
    this.editStatus = this.$route.query.editStatus || '';
  },
  mounted() {
    this.getResponsClassify().then(() => {
      this.getList();
    });
    window.addEventListener('resize', this.calcRangeOverflow);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.calcRangeOverflow);
    this.timeoutSave && clearTimeout(this.timeoutSave);
  },
  methods: {
    calcRangeOverflow() {
      this.$nextTick(() => {
        const box = this.$refs.empRange;
        this.isOverflowRange = box.clientHeight < box.scrollHeight;
      });
    },
    formatDate(value, format) {
      return XEUtils.toDateString(value, format);
    },
    getResponsClassify() {
      return this.$ajax.get(this.$api.common.getDict, { ItemType: 'ResponsWorkClassify' }).then((res) => {
        this.responsWorkClassifys = res.data.rows || [];
      });
    },

    getList() {
      let param = { id: this.id };
      let isNeedInitInnerSave = false;
      this.$ajax.get(this.$api.responsWork.detail.getWorkDetail, param).then(async (res) => {
        //判断审批状态下是否所有工作项内容都已审批过
        const result = res.data.data.entityWork.details || [];
        this.detail = res.data.data.entityWork.work;
        this.isTemporaryWkNo = this.detail.addType == 5 || this.detail.addType == 15;
        const isHasSub = res.data.data.isSub;
        // 如果extend中存在分类数据，优先使用此数据
        const extendData = this.detail.extend ? JSON.parse(this.detail.extend) : [];
        let extendWorkClassifys = [];
        const extendWorkClassifyItem = extendData.find(item => item.ItemType === "ResponsWorkClassify");
        if (extendWorkClassifyItem) {
            extendWorkClassifys = extendWorkClassifyItem.ExtendPairs || [];
            extendWorkClassifys.forEach(item => {
              item.itemKey = item.itemKey || item.ItemKey;
              item.itemDesc = item.itemDesc || item.ItemDesc;
              item.itemValue = item.itemValue || item.ItemValue;
              item.itemGroup = item.itemGroup || item.ItemGroup;
            });
            extendWorkClassifys.sort((a, b) => a.itemKey - b.itemKey);
        }
        const workClassifyList = extendWorkClassifys && extendWorkClassifys.length > 0 ? extendWorkClassifys : this.responsWorkClassifys;
        const tableList = [];
        workClassifyList.forEach(item => {
          tableList.push({
            headerTitle: item.itemDesc,
            workClassify: item.itemKey,
            typeText: item.itemGroup,
            weight: item.itemValue,
            tableData: [],
            tableRef: `tableRef${item.itemKey}`
          });
        });
        this.tableList = tableList;

        let directReports = this.detail.directReports ? JSON.parse(this.detail.directReports) : {};
        let personSubDtos = directReports.Content || '[]';
        personSubDtos = JSON.parse(personSubDtos);
        personSubDtos = personSubDtos.map(item => {
          return {
            wkName: item.WkName,
            wkNo: item.WkNo,
          }
        });
        this.detail.personSubDtos = personSubDtos;
        this.status = this.detail.status;

        this.deptInfo = {
          department: this.detail.department,
          departmentNo: this.detail.departmentNo,
        };

        result.forEach(item => item.expandRowFlag = false)
        const extendDict = extendData.find(item => item.ItemType === "ResponInnerDict");
        
        const extendDictData = extendDict ? extendDict.ExtendPairs || [] : [];
        
        let downMangeItems = [];
        let cultureDictList = [];
        // if (result.length === 0) {
        //   downMangeItems = await this.getDownManageDict();
        //   cultureDictList = await this.getCultureDict();
        // } else {
        const extendDownMangeItems = extendDictData.filter(item => item.ItemType === "ResponseWorItemKPI");
        const extendCultureDict = extendDictData.filter(item => item.ItemType === "ResponseWorItemCorporationCulture");
        downMangeItems = extendDownMangeItems || [];
        cultureDictList = extendCultureDict || [];
        // }
        this.tableList.forEach(tableItem => {
          const tableData = result.filter(item => tableItem.workClassify == item.workClassify);
          if (tableItem.workClassify == 0) {
            
            if (isHasSub && result.length === 0 && downMangeItems.length > 0) {
              downMangeItems.forEach(downMangeItem => {
                let range = [];
                let weight = null;
                if (downMangeItem.ItemValue == 1) {
                  range = downMangeItem.ItemGroup ? downMangeItem.ItemGroup.split('-') : []
                } else if (downMangeItem.ItemValue == 2) {
                  weight = downMangeItem.ItemGroup;
                }
                tableData.push({
                  "id": null,
                  "workId": this.id,
                  "workClassify": tableItem.workClassify,
                  "workItemNo": '',
                  "workItemContent": downMangeItem.ItemKey,
                  "yearTarget": downMangeItem.ItemDesc,
                  "weight": weight,
                  "isInner": true,
                  "itemType": downMangeItem.ItemValue,
                  "innerWeightRange": range,
                })
              })
              isNeedInitInnerSave = true;
            }
            if (isHasSub && result.length > 0 && downMangeItems.length > 0) {
              
              downMangeItems.forEach(downMangeItem => {
                const downManageRow = tableData.find(row => row.workItemContent === downMangeItem.ItemKey);
                if (!downManageRow) return;
                const range = downMangeItem.ItemGroup ? downMangeItem.ItemGroup.split('-') : []
                downManageRow.innerWeightRange = range;
                downManageRow.isInner = true;
                
                if (downMangeItem.ItemValue == 1) {
                  downManageRow.innerWeightRange = range;
                }
              })
            }
          } else if (tableItem.workClassify == 10) {
            if (result.length === 0 && cultureDictList.length > 0) {
              cultureDictList.forEach(cul => {
                let range = []
                let weight = null;
                if (cul.ItemValue == 1) {
                  range = cul.ItemGroup ? cul.ItemGroup.split('-') : []
                } else if (cul.ItemValue == 2) {
                  weight = cul.ItemGroup;
                }
                tableData.push({
                  "id": null,
                  "workId": this.id,
                  "workClassify": tableItem.workClassify,
                  "workItemNo": '',
                  "workItemContent": cul.ItemKey,
                  "yearTarget": cul.ItemDesc,
                  "weight": weight,
                  "isInner": true,
                  "itemType": cul.ItemValue,
                  "innerWeightRange": range,
                })
              })
              isNeedInitInnerSave = true;
            }
            if (result.length > 0 && cultureDictList.length > 0) {
              cultureDictList.forEach(cul => {
                let range = cul.ItemGroup ? cul.ItemGroup.split('-') : []
                const cultureRow = tableData.find(row => row.workItemContent === cul.ItemKey);
                if (!cultureRow) return;
                cultureRow.isInner = true;
                if (cul.ItemValue == 1) {
                  cultureRow.innerWeightRange = range;
                }
              })
            }

          }
          tableItem.tableData = tableData;
        });

        if (this.msgId && this.isApproved && this.detail.approveNo === this.loginWkNo) {
          this.isShowConfirmResultTip = true;
        }
        this.calcRangeOverflow()
        this.$nextTick(() => {
          if (this.isEditable && isNeedInitInnerSave) {
            this.saveAll('inner');
          }
        })
      });
    },
  
    getDownManageDict() {
      return this.$ajax.get(this.$api.common.getDict, { ItemType: 'ResponseWorItemKPI' }).then((res)=>{
        if(res.code === 0) {
          let list = (res.data && res.data.rows) || [];
          list.forEach(item => {
            item.ItemDesc = item.itemDesc || item.ItemDesc;
            item.ItemGroup = item.itemGroup || item.ItemGroup;
            item.ItemKey = item.itemKey || item.ItemKey;
            item.ItemType = item.itemType || item.ItemType;
            item.ItemValue = item.itemValue || item.ItemValue;
            item.ItemValue = this.isConvertibleToNumber(item.ItemValue) ? Number(item.ItemValue) : 0;
          })
          return list;
        }
      }).catch(() => {
        return null;
      })
    },
    getCultureDict() {
      return this.$ajax.get(this.$api.common.getDict, { ItemType: 'ResponseWorItemCorporationCulture' }).then((res)=>{
        if(res.code === 0) {
          let list = (res.data && res.data.rows) || [];
          list.forEach(item => {
            item.ItemDesc = item.itemDesc || item.ItemDesc;
            item.ItemGroup = item.itemGroup || item.ItemGroup;
            item.ItemKey = item.itemKey || item.ItemKey;
            item.ItemType = item.itemType || item.ItemType;
            item.ItemValue = item.itemValue || item.ItemValue;
            item.ItemValue = this.isConvertibleToNumber(item.ItemValue) ? Number(item.ItemValue) : 0;
          })
          return list;
        }
      }).catch(() => {
        return [];
      })
    },
    isConvertibleToNumber(val) {
      // 排除 null 和空字符串（Number(null) 是 0，Number('') 是 0，需按需处理）
      if (val === null || val === '') return false;
      // 转换为数字后，判断是否为有效数字
      return !Number.isNaN(Number(val));
    },
    expandRowAll() {
      this.expandRowAllFlag = !this.expandRowAllFlag;
      if (this.expandRowAllFlag) {
        for (let i = 0; i < this.tableList.length; i++) {
          const tb = this.tableList[i];
          this.$refs[tb.tableRef][0].openAllRow();
        }
      } else {
        for (let i = 0; i < this.tableList.length; i++) {
          const tb = this.tableList[i];
          this.$refs[tb.tableRef][0].closeAllRow();
        }
      }
    },
    
    updateStatus(status) {
      if (this.status === 20) {
        //员工提交工作项目 待审批状态
        if (status == 'access') {
          this.showApprove = false;
          this.$ajax
            .post(this.$api.responsWork.detail.updateStatus, {
              msgObjectId: this.id,
              updateStatus: '30',
              updateReason: this.approveReason,
              msgId: this.msgId,
            })
            .then((res) => {
              this.$message.success(res.data);
              this.reload();
            });
        } else {
          if (this.approveReason) {
            this.showCompleteApprove = false;
            this.$ajax
              .post(this.$api.responsWork.detail.updateStatus, {
                msgObjectId: this.id,
                updateStatus: '10',
                updateReason: this.approveReason,
                msgId: this.msgId,
              })
              .then((res) => {
                this.$message.success(res.data);
                this.reload();
              });
          } else {
            this.$message.error('"驳回原因"为必填项');
          }
        }
      } else {
        this.$message.error('当前状态不能再被审批');
      }
    },
    
    closeApprove() {
      this.approveReason = '';
    },
    
    openAllTable() {
      for (let i = 0; i < this.tableList.length; i++) {
        const tb = this.tableList[i];
        this.$refs[tb.tableRef][0].openTable();
      }
    },

    removeSubEmp(index) {
      this.detail.personSubDtos.splice(index, 1);
      this.$forceUpdate();
      this.saveAll();
      this.calcRangeOverflow();
    },
    showSelectSubEmp() {
      this.isShowPersonSelecter = true;
    },
    selectedSubEmps(list) {
      this.detail.personSubDtos = list;
      this.isShowPersonSelecter = false;
      this.saveAll();
      this.calcRangeOverflow();
    },
    deptChange({department, departmentNo}) {
      this.detail.department = department;
      this.detail.departmentNo = departmentNo;
    },
    formulatChange() {
      this.detail.formulatName = this.$refs.formulatSelect.currentOption.name;
      this.saveAll();
    },
    superiorChange() {
      this.detail.superiorName = this.$refs.superiorSelect.currentOption.name;
      this.saveAll();
    },
    getAllTableData() {
      //获取所有工作项的数据
      let allTableData = [];
      this.tableList.forEach(item => {
        allTableData = allTableData.concat(this.$refs[item.tableRef][0].getTableData());
      });
      return allTableData;
    },
    saveAll(type) {
      if (this.pending) return 0;
      this.pending = true;
      let arr = this.getAllTableData();
      this.detail.jobName = this.$filterSpecialChars(this.detail.jobName);
      const params = {
        ...this.detail,
        personSubDtos: this.detail.personSubDtos,
        responseDetailUpdateDtos: arr,
        EditSource: this.isConfirmPending ? '1' : '0',
      }
      this.$ajax.post(this.$api.responsWork.detail.update, params, { noLoading: true }).then(() => {
        if (type === 'clickSave') {
          this.$message.success('保存成功');
        } else {
          this.saveStatus = '已保存';
          this.timeoutSave && clearTimeout(this.timeoutSave);
          this.timeoutSave = setTimeout(() => {
            this.saveStatus = '';
          }, 1000, this);
        }
        if (type === 'inner') {
          this.getList();
        }
      }).finally(() => {
        this.pending = false;
      });;
    },
    clickSave() {
      this.saveAll('clickSave');
    },
    
    async submit() {
      // 校验数据填写情况
      this.showSubmit = false;
      if (!this.detail.formulatNo) {
        this.$message.error('请填写"制定人"!');
        return false;
      }
      if (this.detail.allowDeptEdit === 1 && !this.detail.departmentNo) {
        this.$message.error('请选择"部门"!');
        return false;
      }
      if (!this.detail.jobName) {
        this.$message.error('请填写"岗位名称"!');
        return false;
      }
      if (!this.detail.superiorNo) {
        this.$message.error('请填写"直接上级"!');
        return false;
      }
      if (this.getAllTableData().length === 0) {
        this.$message.error('请填写工作项后再提交');
        return false;
      }
      this.openAllTable();
      this.$nextTick(async () => {
        for (let i = 0; i < this.tableList.length; i++) {
          const tb = this.tableList[i];
          let tableData = this.$refs[tb.tableRef][0].getTableData();
          if (tableData.length === 0) {
            this.$message({
              type: 'error',
              message: `"${tb.typeText}"至少添加一条数据`,
            });
            return false;
          }
        }
        const errPromise = [];
        for (let i = 0; i < this.tableList.length; i++) {
          const tb = this.tableList[i];
          // errPromise.push(this.$refs[tb.tableRef][0].validateTable());
          const err = await this.$refs[tb.tableRef][0].validateTable()
          if (err) return false;
        }
        Promise.all(errPromise).then((errList) => {
          if (errList && errList.length > 0) {
            const msgList = [];

            errList.forEach((err) => {
              if (!err) return;
              Object.values(err).forEach(e => {
                e.forEach(eItem => {
                  const { rules } = eItem;
                  rules.forEach((rule) => {
                    msgList.push(`校验错误：${rule.message}`);
                  });
                })
              })
            });
            if (msgList.length > 0) {
              this.$message({
                type: 'error',
                message: msgList.join(),
              });
              return false;
            }
          }
          for (let i = 0; i < this.tableList.length; i++) {
            const tb = this.tableList[i];
            let tableData = this.$refs[tb.tableRef][0].getTableData();
            if (tableData.length === 0) {
              return false;
            }
            let weightSum = tableData.reduce((pre, curr) => { return pre + parseInt(curr.weight || 0)}, 0);
            
            if (weightSum != tb.weight) {
              this.$message({
                type: 'error',
                message: `"${tb.typeText}"的权重和必须等于${tb.weight}`,
              });
              return false;
            }
          }

          if (this.status === 0 || this.status === 10) {
            let arr = this.getAllTableData();
            let directReports = this.detail.directReports ? JSON.parse(this.detail.directReports) : {};
            let personSubDtos = this.detail.personSubDtos.map(item => {
              return {
                WkName: item.wkName,
                WkNo: item.WkNo,
              }
            });
            directReports.Content = JSON.stringify(personSubDtos);
            this.detail.directReports = JSON.stringify(directReports);
            const params = {
              ...this.detail,
              responseWorkDetailList: arr,
            }
            this.$ajax.post(this.$api.responsWork.detail.commit, params).then(() => {
              this.$message.success('提交成功');
              this.reload();
            });
          } else {
            this.showSubmit = false;
            this.$message.error('当前状态您的岗位职责表已无法提交！');
          }
        });
      });
    },

    blurField() {
      this.saveAll();
    },
    deptPopHide() {
      this.saveAll();
    },
    approveText(e) {
      this.approveReason = e;
    },
    showConfirmResult() {
      this.isShowConfirmResult = true;
    },
    async confirmResult() {
      // 校验数据填写情况
      this.isShowConfirmResult = false;
      if (!this.detail.formulatNo) {
        this.$message.error('请填写"制定人"!');
        return false;
      }
      if (this.detail.allowDeptEdit === 1 && !this.detail.departmentNo) {
        this.$message.error('请选择"部门"!');
        return false;
      }
      if (!this.detail.jobName) {
        this.$message.error('请填写"岗位名称"!');
        return false;
      }
      if (!this.detail.superiorNo) {
        this.$message.error('请填写"直接上级"!');
        return false;
      }
      if (this.getAllTableData().length === 0) {
        this.$message.error('请填写工作项后再提交');
        return false;
      }
      this.openAllTable();
      this.$nextTick(async () => {
        for (let i = 0; i < this.tableList.length; i++) {
          const tb = this.tableList[i];
          let tableData = this.$refs[tb.tableRef][0].getTableData();
          if (tableData.length === 0) {
            this.$message({
              type: 'error',
              message: `"${tb.typeText}"至少添加一条数据`,
            });
            return false;
          }
        }
        const errPromise = [];
        for (let i = 0; i < this.tableList.length; i++) {
          const tb = this.tableList[i];
          // errPromise.push(this.$refs[tb.tableRef][0].validateTable());
          const err = await this.$refs[tb.tableRef][0].validateTable()
          if (err) return false;
        }
        Promise.all(errPromise).then((errList) => {
          if (errList && errList.length > 0) {
            const msgList = [];

            errList.forEach((err) => {
              if (!err) return;
              Object.values(err).forEach(e => {
                e.forEach(eItem => {
                  const { rules } = eItem;
                  rules.forEach((rule) => {
                    msgList.push(`校验错误：${rule.message}`);
                  });
                })
              })
            });
            if (msgList.length > 0) {
              this.$message({
                type: 'error',
                message: msgList.join(),
              });
              return false;
            }
          }
          for (let i = 0; i < this.tableList.length; i++) {
            const tb = this.tableList[i];
            let tableData = this.$refs[tb.tableRef][0].getTableData();
            if (tableData.length === 0) {
              return false;
            }
            let weightSum = tableData.reduce((pre, curr) => { return pre + parseInt(curr.weight || 0)}, 0);
            
            if (weightSum != tb.weight) {
              this.$message({
                type: 'error',
                message: `"${tb.typeText}"的权重和必须等于${tb.weight}`,
              });
              return false;
            }
          }

          if (this.status === 30) {
            this.$ajax.post(this.$api.responsWork.history.confirm, `"${this.id}"`, {headers: {'Content-type': 'application/json;charset=utf-8'}}).then((res) => {
              this.$message.success('确认成功');
              this.reload();
            });
          }
        });
      });
    },
    exportExcel() {
      let param = { id: this.id };

      let apiURL = this.$api.responsWork.detail.exportFile;
      this.$ajax.get(apiURL, param, { ignore: true, responseType: 'blob' }).then((res) => {
        if (res.data.type == 'application/json') {
          var reader = new FileReader();
          reader.onload = () => {
            var content = reader.result; //内容就在这里
            let json = JSON.parse(content);
            this.$message.error(json.message);
          };
          reader.readAsText(res.data);
        } else {
          const filename = `${this.detail.wkName}${this.detail.year}年岗位职责表`;
          const filetype = 'docx';
          let data = res.data;
          let url = window.URL.createObjectURL(data);
          let a = document.createElement('a');
          document.body.appendChild(a);
          a.href = url;
          a.download = filename + '.' + filetype;
          a.click();
          window.URL.revokeObjectURL(url);
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
.response-detail {
  color: #555;
  height: 100%;
  .header {
    margin-top: -5px;
    .month-title {
      padding: 0 10px;
      line-height: 30px;
      h2 {
        color: $--color-text-primary;
        font-size: 18px;
        font-weight: bold;
        display: inline-block;
      }
      .saveStatus {
        margin-left: 10px;
        font-size: 15px;
        color: #8e9694;
      }
    }
    
  }
  .container {
    margin-top: 15px;
    padding: 20px;
    flex: 1;
    .el-form-item {
      margin-bottom: 12px;
    }
    .search-and-content {
      flex: 1;
      overflow: auto;
      .search {
        .function {
          flex-wrap: wrap;
        }
      }
    }

  }
  ::v-deep .el-dialog__body {
    padding-top: 33px !important;
    text-align: left;
    .sub-content {
      text-align: center;
    }
    h2 {
      font-size: 18px;
      color: $--color-text-primary;
      font-weight: bold;
      margin-bottom: 10px;
    }
    p {
      color: $--color-text-regular;
    }
  }
  ::v-deep .el-dialog__footer {
    text-align: right;
  }
  .normal-form {
    width: 80%;
  }
  ::v-deep .el-input-group__append {
    padding: 0 5px;
  }
}

::v-deep .el-radio-button {
  margin-right: 20px;
  margin-bottom: 15px;
  .el-radio-button__inner {
    border-radius: 20px;
    padding: 0 20px;
    width: 100%;
    line-height: 36px;
    border: 1px solid $--color-primary;
    color: $--color-primary;
  }
}
::v-deep .el-radio-button.is-active .el-radio-button__inner {
  color: $--color-white;
}

.footer {
  text-align: right;
  margin-top: 20px;
  .select-all-program {
    margin-right: 20px;
  }
}

.personal-table {
  border-collapse: collapse;
  font-size: 14px;
  .label-row {
    background-color: #f6f7fb;
  }

  td {
    padding: 5px 10px;
    border: 1px solid #dcdfe6;
  }
  .personal-label {
    padding: 8px 0;
    color: $--color-primary;
  }
  .table-field, .el-select {
    width: 100%;
  }
  .emp-range {
    position: relative;
    height: 72px;
    min-height: 72px;
    overflow: hidden;
    &.emp-range--expand {
      height: auto;
    }
    .float-empty {
      float: right;
      height: 43px;
      width: 2px;
    }
    .select-btn-wrap {
      margin-top: 4px;
      float: right;
      clear: both;
    }
    .range-ellipse {
      margin-right: 18px;
    }
    .select-btn {
      margin-right: 8px;
      padding: 6px 15px;
    }
    .el-tag {
      margin: 4px 8px 4px 0;
    }
  }
  .default-text {
    height: 36px;
    display: flex;
    align-items: center;
  }
  .default-text--disabled {
    color: #8e9694;
  }
  ::v-deep .el-textarea.is-disabled .el-textarea__inner {
    color: #555;
  }
  ::v-deep .el-input.is-disabled .el-input__inner {
    color: #555;
  }
  ::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
    color: $--color-primary;
  }
}
.required-field {
  &::before {
    content: '*';
    color: #f56c6c;
    font-size: 14px;
    padding-right: 4px;
    font-family: Verdana, Arial, Tahoma;
    vertical-align: -2px;
  }
}
::v-deep .footer-center .el-dialog__footer {
  text-align: center;
}
</style>